import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  avatar: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=400&fit=crop&crop=faces',
  text: 'Tengo 62 años y dependía de mi hijo. Este libro me explicó la IA como una charla entre amigos. ¡Increíble!',
  name: 'Elena R.',
  age: '62 años'
}, {
  avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=faces',
  text: 'Sin tecnicismos. Entendí por fin para qué sirve la IA en mi trabajo diario. Altamente recomendado.',
  name: 'Ricardo M.',
  age: '55 años'
}, {
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=faces',
  text: '¿IA a los 48? Este libro demostró que todavía puedo aprender y aplicarlo a mi negocio.',
  name: 'Carmen S.',
  age: '48 años'
}, {
  avatar: 'https://images.unsplash.com/photo-1559963110-71b394e7494d?w=400&h=400&fit=crop&crop=faces',
  text: 'Me vi reflejado en las historias. La IA no viene a reemplazarnos, sino a hacernos el trabajo liviano.',
  name: 'Joaquín T.',
  age: '64 años'
}, {
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=faces',
  text: 'Ya no "fingo" que entiendo en las reuniones. Ahora entiendo de verdad y hasta doy sugerencias.',
  name: 'Mónica V.',
  age: '51 años'
}, {
  avatar: 'https://cdn.magicpatterns.com/uploads/h74W6bHy9UzucNPnQanrWS/Imagen_-_La_glicacion_no_espera.png',
  text: 'En menos de una hora ya estaba probando las herramientas. Si tienes miedo a la tecnología, léelo.',
  name: 'Alberto P.',
  age: '59 años'
}];
// Duplicate the array for seamless infinite loop
const loopItems = [...testimonials, ...testimonials];
export function TestimonialsCarousel() {
  return <section className="w-full bg-crema py-14 md:py-[88px] overflow-hidden" data-id="element-215">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-12" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-217">
          <h2 className="text-[30px] md:text-[36px] font-serif font-bold text-navy leading-[1.25]" data-id="element-218">
            Lo que dicen nuestros lectores
          </h2>
          <p className="text-[16px] font-sans text-[#666666] max-w-[560px] mx-auto mt-3 leading-[1.65]" data-id="element-219">
            Más de 500 personas mayores de 40 años ya han transformado su
            relación con la tecnología.
          </p>
        </motion.div>
      </div>

      {/* Marquee track */}
      <div className="relative marquee-pause" data-id="element-220">
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 md:w-32 bg-gradient-to-r from-crema to-transparent z-10" data-id="element-221" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 md:w-32 bg-gradient-to-l from-crema to-transparent z-10" data-id="element-222" />

        <div className="flex w-max animate-marquee gap-8 px-4" data-id="element-223">
          {loopItems.map((t, i) => <TestimonialCard key={i} t={t} data-id="element-224" />)}
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  t
}: {
  t: {
    avatar: string;
    text: string;
    name: string;
    age: string;
  };
}) {
  return <div className="w-[320px] md:w-[360px] flex-shrink-0 bg-white rounded-2xl p-7 shadow-[0_4px_24px_rgba(0,0,0,0.06)] border border-navy/5 flex flex-col" data-id="element-225">
      <div className="flex items-center gap-4 mb-4" data-id="element-226">
        <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-gold flex-shrink-0" data-id="element-227" />
        <div className="flex gap-0.5" data-id="element-228">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-gold" fill="currentColor" strokeWidth={0} data-id="element-229" />)}
        </div>
      </div>
      <p className="text-[15px] font-sans text-[#4A4A4A] leading-[1.75] italic flex-grow" data-id="element-230">
        "{t.text}"
      </p>
      <p className="text-[14px] font-sans font-bold text-navy mt-5" data-id="element-231">
        {t.name} <span className="font-normal text-[#888888]" data-id="element-232">— {t.age}</span>
      </p>
    </div>;
}